import { LocalizelyLocalizationProviderInfo } from "./SWLocalizelyLocalizationProvider";
import { LokaliseLocalizationProviderInfo } from "./SWLokaliseLocalizationProvider";
import { SuperwallLocalizationProviderInfo } from "./SWSuperwallLocalizationProvider";
export const LocalizationProviderMap = {
    superwall: SuperwallLocalizationProviderInfo,
    lokalise: LokaliseLocalizationProviderInfo,
    localizely: LocalizelyLocalizationProviderInfo
};
